import { render } from "./NftCard.vue?vue&type=template&id=aa9a3d74&scoped=true"
import script from "./NftCard.vue?vue&type=script&lang=js"
export * from "./NftCard.vue?vue&type=script&lang=js"

import "./NftCard.vue?vue&type=style&index=0&id=aa9a3d74&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9a3d74"]])

export default __exports__